import "./Cats.module.css";
import Header from "@/reusable_sections/Header";
import Topics from "./sections/Topics";
import CatQuestions from "./sections/CatQuestions";
import BreedsSpotlight from "./sections/BreedsSpotlight";
import Footer from "@/reusable_sections/Footer";
export default function CatsPage() {
  return <div>
      <Header />
      <Topics />
      <CatQuestions />
      <BreedsSpotlight />
      <Footer />
    </div>;
}